import { useQuery } from 'react-query';
import { getUser, isWeaveUser } from '@frontend/auth-helpers';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';
import { getAccountManagerData, getCSMContactPopupStatusByUserIDAndLocationID } from './api';

export const useAccountManagerDataQuery = () => {
  const { selectedLocationIds, accessibleLocationData } = useAppScopeStore();
  const isMultiLocation = accessibleLocationData[selectedLocationIds[0]]?.locationType !== 'single';
  const locationId = selectedLocationIds[0];
  const locationData = accessibleLocationData[locationId];
  const slug = locationData?.slug ?? '';

  const canViewAccountManagerDetails = isMultiLocation || isWeaveUser();
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const hasAccountManagerFlagEnabled = getFeatureFlagValue('account-manager-profile-view');

  return useQuery({
    queryKey: [slug, 'account-manager'],
    queryFn: async () => {
      try {
        return await getAccountManagerData({ slug });
      } catch (error) {
        console.error('Error fetching account manager data', error);
        return undefined;
      }
    },
    enabled: canViewAccountManagerDetails && hasAccountManagerFlagEnabled && !!slug,
    staleTime: 30000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export const useCSMContactPopupStatusByUserIDAndLocationID = ({ enabled = true }: { enabled?: boolean }) => {
  const { accessibleLocationData, selectedLocationIds } = useAppScopeStore();
  const isMultiLocation = accessibleLocationData[selectedLocationIds[0]]?.locationType !== 'single';
  const locationId = selectedLocationIds[0];
  const user = getUser();

  // PT-TODO: Create a new ACL for viewing account manager details
  const canViewAccountManagerDetails = isMultiLocation || isWeaveUser();

  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const hasAccountManagerFlagEnabled = getFeatureFlagValue('account-manager-profile-view');
  const hasCsmWelcomePopupFlagEnabled = getFeatureFlagValue('csm-welcome-popup');
  const hasFlagsEnabled = hasAccountManagerFlagEnabled && hasCsmWelcomePopupFlagEnabled;

  return useQuery({
    queryKey: [locationId, user?.userID, 'csm-contact-popup-status'],
    queryFn: () => {
      return getCSMContactPopupStatusByUserIDAndLocationID({ locationId, userId: user?.userID ?? '' });
    },
    enabled: enabled && canViewAccountManagerDetails && hasFlagsEnabled && !!locationId && !!user?.userID,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
